class FilterSection {
  constructor(settings) {
    this.body = settings.body;
    this.container = settings.container;
    this.mediaQuery = settings.mediaQuery;
    this.trigger = settings.trigger ? settings.trigger : null;
  }
  bindEvents() {
    this.trigger.addEventListener('click', this.toggleVisibility.bind(this));
  }
  toggleVisibility() {
    this.body.hidden = !this.body.hidden;
    this.trigger.setAttribute('aria-expanded', !this.body.hidden);
  }
  persistantFilters() {
    try {
      const url = new URL(window.location.href);
      const inputs = this.body.querySelectorAll('.c-field__choice-input');

      inputs.forEach((input) => {
        const inputAttr = input.getAttribute('name');
        const inputVal = input.value;
        const paramsMatch = url.searchParams.getAll(inputAttr);

        paramsMatch.forEach((param) => {
          if (param === inputVal) {
            setTimeout(function () {
              input.click();
              input.checked = true;
            }, 100);
          }
        });
      });
    } catch (err) {
      console.error("Issues with Parsing URL Parameter's - " + err);
    }
  }
  init() {
    if (this.trigger === null) return;
    if (this.mediaQuery.matches === true) {
      this.toggleVisibility();
    }
    this.bindEvents();
    this.persistantFilters();
  }
}

export default FilterSection;
